import { openDB } from "idb";

const DB_NAME = "biashara-pos";
const dbp = openDB(DB_NAME, 1, {
  upgrade(d) {
    if (!d.objectStoreNames.contains("kv")) d.createObjectStore("kv");
    if (!d.objectStoreNames.contains("queue")) d.createObjectStore("queue", { keyPath: "uid" });
  },
});

export async function kvGet(k) { return (await dbp).get("kv", k); }
export async function kvSet(k, v) { return (await dbp).put("kv", v, k); }
export async function queueAll() { return (await dbp).getAll("queue"); }
export async function queuePut(op) { return (await dbp).put("queue", op); }
export async function queueDel(uid) { return (await dbp).delete("queue", uid); }
